<template>
  <div v-if="isShow">
    <summary-detail :name="saleName" type="销售" :key-customer-id="saleId" :year="year">
      <div>
        <!--      <span v-if="keyCustomerId" style="float: right"><el-tag type="warning" effect="plain" size="small">重点客户</el-tag></span>-->
        <el-row style="text-align: left;margin: 5px">
          下单频率：<a @click="getMonthlySum" style="color: #E03F3D;font-size: 1.25em;cursor: pointer;">{{
            gFunc.numberFormat(monthlyData.count)
          }}</a> 单/月
          &emsp;
          (1~{{ monthlyData.month }}月)
          <br/>
          月度价值：<span style="color: #E03F3D;font-size: 1.25em">{{ gFunc.numberFormat(monthlyData.money) }}</span> 元/月
          &emsp;(1~{{ monthlyData.month }}月)
          &emsp; &emsp;
          <span style="color: #cb5c13">备注：只算到前一个月截止，因为当月没过完，数据来摊均值不具参考意义。</span>
        </el-row>
        <!--      平台单量-->
        <platform-count-v2 :year="year" :uid-key-id="saleId" :sale-id="saleId"
                        :organization-id="organization_id"/>
        <br/>
        <platform-money-v2 :year="year" :uid-key-id="saleId" :sale-id="saleId"
                        :organization-id="organization_id"/>
        <br/>
        <sale-per-price :year="year" :uid-key-id="saleId" :sale-id="saleId"
                            :organization-id="organization_id"/>
        <br/>
        <artist-v2 :year="year" :uid-key-id="saleId" :sale-id="saleId"
                :organization-id="organization_id"/>
        <br/>
        <brand-v2 :year="year" :uid-key-id="saleId" :sale-id="saleId"
                :organization-id="organization_id"/>
        <br/>
      </div>
    </summary-detail>
  </div>

</template>

<script>
import platformCountV2 from "@/components/summary/detail/platformCountV2";
import platformMoneyV2 from "@/components/summary/detail/platformMoneyV2";
import salePerPrice from "@/components/summary/detail/salePerPrice";
import artistV2 from "@/components/summary/detail/artistV2";
import brandV2 from "@/components/summary/detail/brandV2";
import { saleDetailMonthlySum } from "@/api/dashboard";
import SummaryDetail from "@/views/dashboard/components/Detail.vue";

export default {
  name: "SummaryCustomerDetail",
  components: {SummaryDetail, platformCountV2, platformMoneyV2, salePerPrice, artistV2, brandV2},
  data() {
    return {
      saleName: this.$route.query.saleName,
      saleId: this.$route.query.saleId,
      uidKeyId: this.$route.query.uidKeyId,
      year: this.$route.query.year,
      data: [],
      organization_id: this.$route.query.organization_id || 'ALL',
      monthlyData: {count: 0, money: 0, month: 12},
    }
  },
  computed: {
    isShow() {
      return this.saleId
    }
  },

  created() {
    if (this.isShow) {
      this.getMonthlySum()
    } else {
      this.showModal({
        h: this,
        text: `非法链接,返回上级`,
        confirmText: "",
        cancelText: "",
        confirm: async () => {
          this.$router.go(-1)
        }
      });
    }
  },
  methods: {
    getMonthlySum() {
      this.dataMoney = [];
      saleDetailMonthlySum({
        year: this.year,
        sale_id: this.saleId,
        uid_key_id: this.uidKeyId,
        organization_id: this.organization_id,
      }).then(res => {
        this.monthlyData = res.model
      })
    },
  }
}
</script>

<style>

</style>
